export default __webpack_public_path__ + "static/media/card-icon.ac2765ad.svg";